import React from "react";
import {
  TaskInterface,
  useLeadQuantidade,
  useTarefasLeadV2,
  useTiposTarefas,
} from "services/api";

import * as Styles from "screens/lead/components/cardOportunidades/styles";
import { Popover, Skeleton } from "@mui/material";
import { toast } from "react-toastify";
import { ptBR } from "date-fns/locale";
import ToggleBtns from "components/toggleBtns";
import { useTransformList } from "hooks/objectToLabelValue";
import * as IconsSVG from "../../../../../assets/iconsSVG";
// import { StandarCard } from "./standartCard";
// import { ConcludedCard } from "./concludedCard";
import MaterialUI from "../../../../../material-UI";
import TaskCard from "./components/TaskCard";
import ConcludeTaskCard from "./components/ConcludeTaskCard";
import GradientButtonPlus from "../../../../../components/GradientButton";
import DialogCommon from "../../../../../components/dialogCommon";
import EditTaskV2 from "../../../../../components/dialogCommon/templates/EditTaskV2";
import NewTaskV2 from "../../../../../components/dialogCommon/templates/NewTaskV2";
import ConcludeTaskV2 from "../../../../../components/dialogCommon/templates/ConcludeTaskV2";

interface Props {
  idLead: string | undefined;
  accordionOpen: boolean;
  onChange?: (val: boolean) => void;
  onOpenNewTask: () => void;
  avoidRefetch: boolean;
  onOpenEditTask: (val: any) => void;
  onOpenConcludeTask: (val: any) => void;
  dataLead: any;
  refetchDataLead: () => void;
}
function TarefaSection(props: Props) {
  const [statusTarefa, setStatusTarefa] = React.useState<1 | 2 | 3>(1);
  const [taskFilter, setTaskFilter] = React.useState<{
    InicioIntervaloCadastroTarefa: string | null;
    FimIntervaloCadastroTarefa: string | null;
    idsTiposTarefa: string[] | null;
  }>({
    InicioIntervaloCadastroTarefa: null,
    FimIntervaloCadastroTarefa: null,
    idsTiposTarefa: null,
  });
  const [modalNewTask, setModalNewTask] = React.useState(false);
  const [modalConcludeTask, setModalConcludeTask] = React.useState(false);
  const [modalEditTask, setModalEditTask] = React.useState(false);
  const [taskSelected, setTaskSelected] = React.useState<any>(null);
  const {
    data: dataLeadQuantidade,
    refetch: refetchLeadQuantidade,
    isSuccess: isSuccessLeadQuantidade,
    isFetching: isFetchingLeadQuantidade,
  } = useLeadQuantidade({
    queryKey: "lead-quantidade-query",
    idLead: props.idLead || "",
  });

  const {
    data: tarefasData,
    refetch: refetchTarefasData,
    isFetching,
  } = useTarefasLeadV2({
    queryKey: "tarefas-lead-hierarquia",
    idLead: props.idLead || "",
    StatusTarefa: statusTarefa,
    idsTiposTarefa: taskFilter.idsTiposTarefa,
    InicioIntervaloCadastroTarefa: taskFilter.InicioIntervaloCadastroTarefa,
    FimIntervaloCadastroTarefa: taskFilter.FimIntervaloCadastroTarefa,
  });

  const {
    data: dataTiposTarefas,
    refetch: refetchTiposTarefas,
    isFetching: isFetchingTiposTarefas,
  } = useTiposTarefas({
    queryKey: "tipos-tarefas-filtros",
  });

  React.useEffect(() => {
    if (props.avoidRefetch === false) {
      refetchLeadQuantidade();
    }
  }, []);

  React.useEffect(() => {
    if (isSuccessLeadQuantidade && props.avoidRefetch === false) {
      if (
        dataLeadQuantidade?.quantidadeTarefasAtrasadas &&
        dataLeadQuantidade?.quantidadeTarefasAtrasadas > 0
      ) {
        document.getElementById("atrasadasBtn")?.click();
      } else if (dataLeadQuantidade?.quantidadeTarefaEmAberto > 0) {
        document.getElementById("emAbertoBtn")?.click();
      } else {
        document.getElementById("concluidasBtn")?.click();
      }
    }
  }, [isSuccessLeadQuantidade]);

  const handleStatusTarefa = async (
    statusNumber: 1 | 2 | 3,
    quantidadeTipo: number | undefined
  ) => {
    if (quantidadeTipo === 0) {
      toast?.warning("Não há tarefas desse tipo para esse lead", {
        autoClose: 5000,
      });
    } else {
      await setStatusTarefa(statusNumber);
      refetchTarefasData();
    }
  };

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    refetchTiposTarefas();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleConcludeTask = () => {
    refetchTarefasData();
    props.refetchDataLead();
  };

  const handleClearFilter = async () => {
    await setTaskFilter({
      InicioIntervaloCadastroTarefa: null,
      FimIntervaloCadastroTarefa: null,
      idsTiposTarefa: null,
    });
    refetchTarefasData();
  };

  const handleAplicarFiltros = async () => {
    await refetchTarefasData();
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const transformedTiposTarefas = useTransformList({
    inputList: dataTiposTarefas?.data,
    labelField: "nome",
    valueField: "id",
  });

  const verifyQuantityTasks =
    dataLeadQuantidade?.quantidadeTarefaConcluidas === 0 &&
    dataLeadQuantidade?.quantidadeTarefaEmAberto === 0 &&
    dataLeadQuantidade?.quantidadeTarefasAtrasadas === 0;

  const refetchAll = () => {
    refetchTarefasData();
    refetchLeadQuantidade();
  };

  return (
    <>
      <Styles.Container>
        <Styles.HeaderTarefas>
          <Styles.ButtonsGrid>
            {isFetchingLeadQuantidade ? (
              <>
                <Skeleton variant="rounded" width="100px" height="40px" />
                <Skeleton variant="rounded" width="100px" height="40px" />
                <Skeleton variant="rounded" width="100px" height="40px" />
              </>
            ) : (
              <>
                {!verifyQuantityTasks ? (
                  <>
                    <Styles.ButtonTarefas
                      id="concluidasBtn"
                      onClick={() =>
                        handleStatusTarefa(
                          3,
                          dataLeadQuantidade?.quantidadeTarefaConcluidas
                        )
                      }
                      isSelected={statusTarefa === 3}
                    >
                      Concluída (
                      {dataLeadQuantidade?.quantidadeTarefaConcluidas})
                    </Styles.ButtonTarefas>
                    <Styles.ButtonTarefas
                      id="atrasadasBtn"
                      onClick={() =>
                        handleStatusTarefa(
                          1,
                          dataLeadQuantidade?.quantidadeTarefasAtrasadas
                        )
                      }
                      isSelected={statusTarefa === 1}
                    >
                      Atrasada ({dataLeadQuantidade?.quantidadeTarefasAtrasadas}
                      )
                    </Styles.ButtonTarefas>
                    <Styles.ButtonTarefas
                      onClick={() =>
                        handleStatusTarefa(
                          2,
                          dataLeadQuantidade?.quantidadeTarefaEmAberto
                        )
                      }
                      isSelected={statusTarefa === 2}
                      id="emAbertoBtn"
                    >
                      Em Aberto ({dataLeadQuantidade?.quantidadeTarefaEmAberto})
                    </Styles.ButtonTarefas>
                  </>
                ) : (
                  <></>
                )}
              </>
            )}
            <GradientButtonPlus onClick={() => setModalNewTask(true)} />
            <Styles.ButtonTarefas
              style={{ width: "50px" }}
              isSelected={false}
              onClick={handleClick}
            >
              <IconsSVG.FilterIconBlue />
            </Styles.ButtonTarefas>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <Styles.ModalContent>
                <Styles.HeaderModal>
                  <IconsSVG.FilterModalIcon />
                  <Styles.HeaderModalTitle>Filtros</Styles.HeaderModalTitle>
                  <Styles.ClearBtn onClick={handleClearFilter}>
                    Limpar
                  </Styles.ClearBtn>
                </Styles.HeaderModal>
                <div style={{ marginTop: 16 }}>
                  <Styles.LabelModal>Período</Styles.LabelModal>
                  <Styles.LocalizationProvider
                    locale={ptBR}
                    dateAdapter={MaterialUI.AdapterDateFns}
                  >
                    <Styles.Row>
                      <Styles.ContentDate>
                        <Styles.DesktopDatePicker
                          inputFormat="dd/MM/yyyy"
                          value={taskFilter?.InicioIntervaloCadastroTarefa}
                          components={{
                            OpenPickerIcon: IconsSVG.CalendarIcon,
                          }}
                          disabled={false}
                          InputAdornmentProps={{ position: "start" }}
                          onChange={(newValue: any) =>
                            setTaskFilter({
                              ...taskFilter,
                              InicioIntervaloCadastroTarefa: newValue,
                            })
                          }
                          renderInput={(params: any) => (
                            <>
                              <Styles.LabelText>De</Styles.LabelText>
                              <Styles.TextField
                                size="small"
                                InputLabelProps={{ shrink: false }}
                                variant="outlined"
                                {...params}
                                label="De"
                                fullWidth
                              />
                            </>
                          )}
                        />
                      </Styles.ContentDate>
                      <Styles.ContentDate>
                        <Styles.DesktopDatePicker
                          inputFormat="dd/MM/yyyy"
                          value={taskFilter?.FimIntervaloCadastroTarefa}
                          disabled={false}
                          components={{
                            OpenPickerIcon: IconsSVG.CalendarIcon,
                          }}
                          InputAdornmentProps={{ position: "start" }}
                          onChange={(newValue: any) =>
                            setTaskFilter({
                              ...taskFilter,
                              FimIntervaloCadastroTarefa: newValue,
                            })
                          }
                          minDate={taskFilter?.InicioIntervaloCadastroTarefa}
                          renderInput={(params: any) => (
                            <>
                              <Styles.LabelText>Até</Styles.LabelText>
                              <Styles.TextField
                                size="small"
                                InputLabelProps={{ shrink: false }}
                                variant="outlined"
                                {...params}
                                label="Até"
                                fullWidth
                                error={false}
                                helperText={""}
                              />
                            </>
                          )}
                        />
                      </Styles.ContentDate>
                    </Styles.Row>
                  </Styles.LocalizationProvider>
                </div>
                <div style={{ marginTop: 16 }}>
                  <Styles.LabelModal>Tipo de tarefa</Styles.LabelModal>
                  {isFetchingTiposTarefas ? (
                    <>
                      <Skeleton variant="rounded" width="350px" height="75px" />
                    </>
                  ) : (
                    <>
                      <ToggleBtns
                        data={transformedTiposTarefas}
                        value={taskFilter?.idsTiposTarefa}
                        onChange={(newValues: any) => {
                          setTaskFilter({
                            ...taskFilter,
                            idsTiposTarefa: newValues,
                          });
                        }}
                      />
                    </>
                  )}
                </div>
                <Styles.FooterModal>
                  <Styles.ButtonModal onClick={handleAplicarFiltros}>
                    Aplicar filtro
                  </Styles.ButtonModal>
                </Styles.FooterModal>
              </Styles.ModalContent>
            </Popover>
          </Styles.ButtonsGrid>
        </Styles.HeaderTarefas>
        <Styles.CardsSection>
          {/* {tarefasData?.data?.tarefas?.length > 0
            ? tarefasData?.data?.tarefas?.map((item: TaskInterface) => (
                <TaskCard />
              ))
            : null} */}
          {isFetching ? (
            <>
              <Skeleton variant="rounded" width="100%" height="5rem" />
              <Skeleton variant="rounded" width="100%" height="5rem" />
              <Skeleton variant="rounded" width="100%" height="5rem" />
            </>
          ) : (
            <>
              {tarefasData?.data?.tarefas ? (
                <>
                  {tarefasData?.data?.tarefas.length > 0 ? (
                    tarefasData?.data?.tarefas
                      ?.filter(
                        (item: TaskInterface) =>
                          item.tipoTarefa !== "Solicitação de Especialista"
                      )
                      .map((ite: TaskInterface) => (
                        <div key={ite?.idTarefaLead}>
                          {ite.codigoStatusTarefa === 3 ? (
                            <ConcludeTaskCard
                              key={ite?.idTarefaLead}
                              data={ite}
                              statusTarefa={ite?.codigoStatusTarefa}
                            />
                          ) : (
                            <TaskCard
                              key={ite?.idTarefaLead}
                              data={ite}
                              statusTarefa={ite?.codigoStatusTarefa}
                              onOpenEditTask={(val: any) => {
                                setTaskSelected(val);
                                setModalEditTask(true);
                              }}
                              onOpenConcludeTask={(val: any) => {
                                setTaskSelected(val);
                                setModalConcludeTask(val);
                              }}
                            />
                          )}
                        </div>
                      ))
                  ) : (
                    <>
                      <Styles.Text>Sem tarefas para esse lead.</Styles.Text>
                    </>
                  )}
                </>
              ) : (
                <></>
              )}
            </>
          )}
          {verifyQuantityTasks ? (
            <Styles.Text>Sem tarefas para esse lead.</Styles.Text>
          ) : (
            <></>
          )}
        </Styles.CardsSection>
      </Styles.Container>
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setModalNewTask}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Agendar tarefa"
        isFilter={false}
        isClose
        width={712}
        height={620}
        maxHeight="680px"
        component={
          <NewTaskV2
            idLead={props?.dataLead?.idLead}
            idLeadCorretor={props?.dataLead?.idLeadCorretor}
            dataLead={props?.dataLead}
            lead={{
              idLeadCorretor: props?.dataLead?.idLeadCorretor,
              nomeLead: props?.dataLead?.nomeLead,
            }}
            closeModal={() => {
              setModalNewTask(false);
            }}
            refetch={refetchAll}
            refetchDataLead={() => props?.refetchDataLead()}
          />
        }
        setOpenModal={setModalNewTask}
        open={modalNewTask}
        icon={<IconsSVG.NewTaskDialog />}
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setModalEditTask}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Editar tarefa"
        isFilter={false}
        isClose
        width={712}
        height={620}
        component={
          <EditTaskV2
            idLead={props?.dataLead?.idLead}
            idLeadCorretor={props?.dataLead?.idLeadCorretor}
            dataTask={taskSelected}
            closeModal={() => {
              setModalEditTask(false);
            }}
            refetch={() => refetchTarefasData()}
          />
        }
        setOpenModal={setModalEditTask}
        open={modalEditTask}
        icon={<IconsSVG.NewTaskDialog />}
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setModalConcludeTask}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Concluir tarefa"
        isFilter={false}
        isClose
        width={712}
        height={620}
        component={
          <ConcludeTaskV2
            idLead={props?.dataLead?.idLead}
            idLeadCorretor={props?.dataLead?.idLeadCorretor}
            dataTask={taskSelected}
            dataLead={props?.dataLead}
            closeModal={() => {
              setModalConcludeTask(false);
            }}
            refetch={() => handleConcludeTask()}
          />
        }
        setOpenModal={setModalConcludeTask}
        open={modalConcludeTask}
        icon={<IconsSVG.NewTaskDialog />}
      />
    </>
  );
}

export default TarefaSection;
